module.exports = __webpack_public_path__ + "ad2e1a2fad1c8d9a02279d5da25cdd8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-16.png
// module id = 2382
// module chunks = 0